import axiosInstance from '../../utils/axiosConfig';
import {getFinancialDocumentByAssociatedDocument} from "./claimManagement";

export const uploadFile = (formData, onProgress) => async (dispatch) => {
    try {
        const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_FILEMANAGEMENT}/api/file`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (event) => {
                if (onProgress && event.total) {
                    onProgress(Math.round((event.loaded / event.total) * 100));
                }
            }
        });
        dispatch({
            type: 'UPLOAD_SUCCESS',
            payload: response.data,
        });
        return response.data
    } catch (error) {
        dispatch({
            type: 'UPLOAD_FAILURE',
            payload: error.response ? error.response.data : 'Server error',
        });
    }
};

export const addMetaDataToFile = (uid, metaData) => async (dispatch) => {
    try {
        const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_FILEMANAGEMENT}/api/addMetaDataToFile/${uid}`, metaData);
        dispatch({
            type: 'ADD_METADATA_SUCCESS',
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: 'ADD_METADATA_FAILURE',
            payload: error.response ? error.response.data : 'Server error',
        });
    }
};

export const getAllFileForClaim = (claimNumber) => async (dispatch) => {
    try {
        const url = `${process.env.REACT_APP_BACKEND_URL_MS_FILEMANAGEMENT}/api/searchFile`;
        let body = [
            {
                "key": "NUM_SIN", "value": claimNumber
            },

        ]

        const response = await axiosInstance.post(url , body );

        const filesWithComments = await Promise.all(
            response.data.map(async (file) => {
                const documentType = file.metadata.find(meta => meta.key === 'TYPE_DOCUMENT')?.value;
                if (documentType === 'QUOTATION' || documentType === 'INVOICE') {
                    try {
                        const financialDoc = await getFinancialDocumentByAssociatedDocument(file?.file?.uid);
                        console.log("financialDoc", financialDoc)
                        console.log("file", file)
                        console.log("financialDoc?.data", financialDoc?.data)
                        return {
                            ...file,
                            comment: financialDoc?.data?.[0]?.comment,
                            status: financialDoc?.data?.[0]?.status
                        };
                    } catch (error) {
                        console.error(`Error fetching financial doc for ${file.file.uid}:`, error);
                        return file;
                    }
                }
                return file;
            })
        );

        dispatch({
            type: 'GET_FILE_CLAIM_SUCCESS',
            payload: filesWithComments,
        });
        console.log("filesWithComments", filesWithComments)
        return filesWithComments;
    } catch (error) {
        dispatch({
            type: 'GET_FILE_CLAIM_DETAILS',
            payload: error.response ? error.response.data : 'Server error',
        });
        throw error;
    }
};

export const getAllDocClaim = (claimNumber)=> async (dispatch)=> {
try {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_FILEMANAGEMENT}/api/searchFile`;
    let body = [
        {
            "key": "NUM_SIN", "value": claimNumber
        },
        {
            "key": "TYPE_DOCUMENT", "value": "INVOICE"
        },
        {
            "key": "TYPE_DOCUMENT", "value": "QUOTATION"
        },
        {
            "key": "TYPE_DOCUMENT", "value": "CIN"
        } ,
        {
            "key": "TYPE_DOCUMENT", "value": "DRIVING_LICENCE"
        },
        {
            "key": "TYPE_DOCUMENT", "value": " CLAIM_REPORTING_DOCUMENT"
        },
        {
            "key": "TYPE_DOCUMENT", "value": "CAR_REGISTRATION"
        },
        {
            "key": "TYPE_DOCUMENT", "value": "VOUCHER"
        }  
    ]
    const response = await axiosInstance.post(url , body ); 
    dispatch({
        type: 'GET_DOC_CLAIM_SUCCESS',
        payload: response.data,
    });
        return response.data
    } catch (error) {
        dispatch({
        type: 'GET_DOC_CLAIM_DETAILS',
        payload: error.response? error.response.data : 'Server error',
        });
    }
    }

export function postImageMs_filemanagement(listImages, imageType, claimNumber, currentUser, progressCallback) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            uploadImagesMs_filemanagement(
                listImages,
                0,
                imageType,
                claimNumber,
                currentUser,
                dispatch,
                progressCallback)
                .then(resolve)
                .catch(reject);
        });
    };
}


function uploadImagesMs_filemanagement(
    listImages,
    index,
    imageType,
    claimNumber,
    currentUser,
    dispatch,
    progressCallback
) {
    if (index === listImages.length) {
        return Promise.resolve();
    } else {
        const formData_filemanagement = new FormData();

        formData_filemanagement.append("fileUploaded", listImages[index]);
        formData_filemanagement.set("value", claimNumber);
        formData_filemanagement.set("key", "NUM_SIN");
        formData_filemanagement.set('createdBy', currentUser);

        return axiosInstance
            .post(
                `${process.env.REACT_APP_BACKEND_URL_MS_FILEMANAGEMENT}/api/file`,
                formData_filemanagement,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            )
            .then((response) => {
                const fileId = response.data.uid;
                return axiosInstance.post(
                    `${process.env.REACT_APP_BACKEND_URL_MS_FILEMANAGEMENT}/api/addMetaDataToFile/${fileId}`,
                    {
                        "key": "TYPE_DOCUMENT",
                        "value": imageType
                    }
                ).then(() => {
                    // dispatch an action to add the new image to the store
                    dispatch({
                        type: 'ADD_IMAGE',
                        payload: {
                            image: listImages[index],
                            fileId,
                            imageType,
                            claimNumber,
                            currentUser
                        }
                    });
                });
            })
            .catch((err) => {
                console.log("err uploading image in ms_filemanagement", err);
                throw err;
            })
            .finally(() => {
                if (progressCallback) {
                    progressCallback(
                        Math.round(((index + 1) / listImages.length) * 100),
                        index + 1
                    );
                }
                return uploadImagesMs_filemanagement(
                    listImages,
                    index + 1,
                    imageType,
                    claimNumber,
                    currentUser,
                    dispatch,
                    progressCallback
                );
            });
    }
}

export const deleteFileImage = (uidFile) => async (dispatch) => {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_FILEMANAGEMENT}/api/deleteFile/${uidFile}`;
    try {
      const response = await axiosInstance.delete(url); 
      dispatch({
        type: 'DELETE_FILE_SUCCESS',
        payload: uidFile,
      });
      return response.data;
    } catch (err) {
      console.error(err);
      dispatch({
        type: 'DELETE_FILE_FAILURE',
        payload: err.response ? err.response.data : 'Server error',
      });
      throw err;
    }
  };
